import { stringify } from 'qs';

/**
 * MOMA API URL.
 */
const MOMA_API_URL = process.env.VUE_APP_MOMA_API_URL;

export default {
    /**
     * Returns callback that returns MOMA API URL for given endpoint
     * with query.
     * @params {string} endpoint - The endpoint to be called.
     * @params {Object} query - Object containing query paramaters.
     */
    momaURL: ({ momaKey }) => (endpoint, query) => {
        const queryString = stringify({
            key: momaKey,
            ...query,
        });
        return `${MOMA_API_URL}/${endpoint}?${queryString}`;
    },

    /**
     * If both API keys are present, return true.
     * @type {boolean}
     */
    isAuthorized: ({ apiKey, momaKey }) => !!(apiKey && momaKey),
};
